export const getTabButtonId = (name: string): string => `${name}-id`;
export const getTabPanelId = (name: string): string => `${name}-panel`;
